/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar5 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar5", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M15.073,21.734 c-1.636,0-2.729-0.962-2.754-2.241h1.626c0.083,0.518,0.552,0.859,1.143,0.859c0.654,0,1.118-0.449,1.118-1.138 c0-0.703-0.469-1.172-1.123-1.172c-0.498,0-0.85,0.225-1.074,0.581h-1.577l0.332-4.126h4.688v1.396h-3.306l-0.132,1.636h0.093 c0.273-0.439,0.771-0.723,1.494-0.723c1.338,0,2.295,0.991,2.295,2.363C17.896,20.694,16.772,21.734,15.073,21.734z M24,10H6V6h18 V10z" />
      </svg>
    );
  }
}

IconCalendar5.defaultProps = {
  className: null
};

IconCalendar5.propTypes = {
  className: PropTypes.string
};

export default IconCalendar5;
